import React from 'react';
import {Table, Card, Button, Select, Typography, Space, notification} from "antd";
import {emVatReportList, visualize, em_vat_report} from '../api/api'
import { StandardVATReportType } from '../utils/constants';

export const EMVATReportGeneric = (props)=>{

    const [em,setEm] = React.useState(props.em)
    const [report,setReport] = React.useState(props.report_type)
    const [source, setSource] = React.useState([]);

    const load = async ()=>{
        if(em && report) {
            console.log(em, report)
            const {data:{rows=[]}} = await emVatReportList({id:em, report_type: report})
            setSource(rows)
        }else
            setSource([])
    }

    React.useEffect(()=>{
        load();
    },[em, report])

    return <React.Fragment>
        <Card>
            {<Table
                dataSource={source}
                pagination={false}
                size={`small`}
            >

                {report === StandardVATReportType.NON_EU_COUNTRY_IMPORT && <Table.Column title={'Country'} render={(value, row, index)=>{
                    return <Space key={index}>
                        <Select showSearch optionFilterProp={'children'} placeholder="Select a country" className={"select"}
                                onChange={async (e) => {
                            row.country = e;
                        }}>
                            <Select.Option key={'UK'} value={'United Kingdom of Great Britain and Northern Ireland (the)'} className={'selectOption'}>United Kingdom of Great Britain and Northern Ireland (the)</Select.Option>
                            <Select.Option key={'CH'} value={'Switzerland'} className={'selectOption'}>Switzerland</Select.Option>
                            <Select.Option key={'NO'} value={'Norway'} className={'selectOption'}>Norway</Select.Option>
                        </Select>
                    </Space>;
                }}/>}

                <Table.Column title={'Report CSV'} render={(value, row, index)=>{
                    return <Space key={index}>
                        <Button onClick={async ()=>{
                            if (row.report_type === StandardVATReportType.NON_EU_COUNTRY_IMPORT && !row.country) {
                                notification.warn({message: `Please select required Country first, and than press Download CSV button.`});
                            } else {
                                await em_vat_report(row.em_id, row.report_type, row.id, row.duration, row.country, 'csv')
                            }
                        }}>Download CSV</Button>
                    </Space>;
                }}/>
                               
                <Table.Column dataIndex={'duration'} title={'Duration'} render={(value,row,index)=>{
                    const data = value.split(",").map(o=>{
                        return o.match(/\d{4}-\d{2}-\d{2}/g) || "STARTED"
                    }).join(" - ")
                    return <Typography.Text>{data}</Typography.Text>
                }}/>

            </Table>}
        </Card>

    </React.Fragment>
}